import { mergeAttributes, Node } from "@tiptap/core";

/**
 * TipTap atom node that preserves source-map-link citation badges
 * through the edit/save cycle in report sections.
 *
 * These inline anchors carry data-section-id / data-first-page-id /
 * data-bates-range attributes that link report text to source documents.
 * Without this extension, TipTap would strip the <a> tags on parse and
 * the citation metadata would be permanently lost on save.
 */
export const SourceMapLink = Node.create({
  name: "sourceMapLink",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      sectionId: { default: null },
      firstPageId: { default: null },
      batesRange: { default: null },
      label: { default: "" },
    };
  },

  parseHTML() {
    return [
      {
        tag: "a",
        priority: 51,
        getAttrs: (dom) => {
          const el = dom as HTMLElement;
          if (!el.classList.contains("source-map-link")) return false;
          return {
            sectionId: el.getAttribute("data-section-id"),
            firstPageId: el.getAttribute("data-first-page-id"),
            batesRange: el.getAttribute("data-bates-range"),
            label: el.textContent || "",
          };
        },
      },
    ];
  },

  renderHTML({ node }) {
    const attrs: Record<string, string> = {
      class: "source-map-link",
      href: "#",
      role: "button",
    };
    if (node.attrs.sectionId) {
      attrs["data-section-id"] = node.attrs.sectionId;
    }
    if (node.attrs.firstPageId) {
      attrs["data-first-page-id"] = node.attrs.firstPageId;
    }
    if (node.attrs.batesRange) {
      attrs["data-bates-range"] = node.attrs.batesRange;
    }
    return ["a", mergeAttributes(attrs), node.attrs.label];
  },
});
